import { Success } from '@starsoft/common/models';
import { FetchSendValidationCodeRequestDto } from '../../../../dto/withdrawals/fetch-send-validation-code-request.dto';
import { AxiosInstance } from 'axios';

export async function fetchSendCode(
  { emailId }: FetchSendValidationCodeRequestDto,
  axiosInstance: AxiosInstance,
) {
  const response = await axiosInstance.post<Success>('/withdrawals/send-code', {
    emailId,
  });

  return response.data;
}
